$(document).ready(function () {

/* ✅ Product Popup */
 $(document).on('click', '.mixmatch_grid', function(e) {
    // Prevent clicking inner add button from reopening popup
    if ($(e.target).closest('.addtoset-checkbox, .m-atc').length) return;
const product__id = $(this).attr('data-product-id');
    const title = $(this).attr('productTitle');
    const price = $(this).attr('productPrice');
    const comprice = $(this).attr('comparePrice');
    const proimg = $(this).attr('productImage');
    const buttontext = $(this).find('.addtoset-checkbox-wrapper .m-atc').text();
    
    const thumbimages = $(this).find('.product__defaultthumb').html();
    $('#popup-title').text(title);
    $('#popup-price').text(price);
    $('#popup-compriceprice').text(comprice);
    $('#popup-image').attr('src', proimg);
    $('#popup-add').text(buttontext);
    if (buttontext == 'Added'){
      $('#popup-add').addClass('addedtext');
    }else {
    $('#popup-add').removeClass('addedtext');
  }  
    $('#product-popup').addClass('active');
    $('.product__thumb').html(thumbimages);
    $('#popup-add').attr('data-popup-product', product__id );
    $('.product_description_pop').html($(this).find('.productdesc_hidden').html());
  }); 

  $(document).on('click', function(e) {
  if (
    $(e.target).is('#product-popup') || 
    $(e.target).is('.popup-close')
  ) {
    $('#product-popup').removeClass('active');
  }
});



// ✅ Main image change on thumb click
  $(document).on('click', '.media__thumb', function() {
      const thumbsrc = $(this).attr('data-imagesrc');
    $('#popup-image').attr('src',thumbsrc);
  }); 
  // ✅ Add from popup button click
  $(document).on('click', '#popup-add', function() {
      const clickedProductpop = $(this).attr('data-popup-product');
    $('.mixmatch_grid[data-product-id="'+clickedProductpop+'"]').find('.addtoset-checkbox-wrapper, .addtoset-checkbox').trigger('click');
        $(this).toggleClass('addedtext').text($(this).hasClass('addedtext') ? 'Added' : 'Add to cart');
  });

  


  $(document).on('input', '#mixmatch-search', function () {
    const searchValue = $(this).val().toLowerCase().trim();
    $('.featured-product .mixmatch_grid').each(function () {
      const productTitle = $(this).find('.product__title').text().toLowerCase();
      if (productTitle.includes(searchValue)) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
    
    if ($('.featured-product .mixmatch_grid:visible').length === 0) {
      if ($('#no-results').length === 0) {
        $('.featured-product').append('<div id="no-results" style="text-align:center;padding:20px;">No products found</div>');
      }
    } else {
      $('#no-results').remove();
    }
  });

  $(document).on('change', 'select.box_value', function () {
    $('.addtoset-checkbox.active.addtoset-checkbox-active').trigger('click');
    $(".selected_product").html('');
    const selOption = parseInt($(this).find('option:selected').val(), 10) || 3;
    $('.featured-product.product').attr('max_limit', selOption);
    $('.box_block.updatelist').first().addClass('add_item_box');

     $('#progressBar').css('width', '0%');
  });
  
  
  $(document).on('click', '.addtoset-checkbox-wrapper', function () {
  let total = 0;            
  let regularTotal = 0;     
  let index = 0;
  let productList = [];

  const max_itemAdd = parseInt($('.featured-product.product').attr('max_limit'), 10) || 3;
  $('.formbunder input[name^="properties["]').remove();

  $(".addtoset-checkbox-active").each(function () {
    index++;
    const productprice = parseFloat($(this).attr("data-productprice")) || 0;
    const regularprice = parseFloat($(this).attr("data-compareprice")) || productprice; // fallback
    total += productprice;
    regularTotal += regularprice;
    const titleresult = $(this).attr('data-producttitle');
    productList.push(titleresult);
  });

  const formattedDiscounted = new Intl.NumberFormat().format(total);
  const formattedRegular = new Intl.NumberFormat().format(regularTotal);
  const savedAmount = regularTotal > total ? regularTotal - total : 0;
  const formattedSaved = new Intl.NumberFormat().format(savedAmount);

  // Get Shopify currency dynamically
let currencySymbol = "";
if (typeof Shopify !== "undefined" && Shopify.currency && Shopify.currency.active) {
  const currency = Shopify.currency.active;

  const symbols = {
    USD: "$",
    CAD: "$",
    GBP: "£",
    EUR: "€",
    INR: "₹",
    AUD: "$",
    NZD: "$",
    SGD: "$",
    JPY: "¥",
    AED: "د.إ",
    SAR: "﷼",
  };

  currencySymbol = symbols[currency] || currency; // fallback to code
} else {
  currencySymbol = "$"; // fallback
}

// Use symbol in dynamic pricing output
if (regularTotal > total) {
  $(".floating-price").html(
    `Total: <span class="floating-price-count final-price">${currencySymbol}${formattedDiscounted}</span> <span class="compare-price" style="text-decoration: line-through; opacity: 0.7; margin-right: 6px;">${currencySymbol}${formattedRegular}</span>`
  );
} else {
  $(".floating-price").html(
    `<span class="floating-price-count">${currencySymbol}${formattedDiscounted}</span>`
  );
}

if (savedAmount > 0) {
  $(".floating-qtyCount").html(
    `<span>Save: ${currencySymbol}${formattedSaved}</span>`
  );
} 

  
  if (productList.length > 0) {
    const formattedList = "\n\n- " + productList.join("\n- ");
    $('.formbunder').append(`<textarea name="properties[Bundle Details]" style="display:none;">${formattedList}</textarea>`);
  }

  const activeCount = $(".addtoset-checkbox-active").length;
  $('.mix_match_products').toggleClass('max_item_added', activeCount === max_itemAdd);
  $('.bundles-atc-wrapper').toggleClass('selection_disabled', activeCount === max_itemAdd);
});



  $(document).on('click', '.addtoset-checkbox', function () {
    const atc_btn = document.querySelector('.bundles-atc');
    const max_itemAdd = parseInt($('.featured-product.product').attr('max_limit'), 10) || 3;
    const parentt = $(this).closest('.mixmatch_grid');
    const parentImage = parentt.find('.product__media-wrapper img').first().attr('src');
    const selected_mixmatch_grid = parentt.attr('data-product-id');
    const isActive = $(this).hasClass("active");

    if (isActive) {
      $(`#title-list .updatelist[linked_box="${selected_mixmatch_grid}"]`)
        .removeAttr('linked_box')
        .empty()
        .removeClass('added')
        .append('<div class="placeholder-box"></div>');
    } else {
      const $emptySlot = $('#title-list .updatelist:not([linked_box])').first();
      if ($emptySlot.length) {
        $emptySlot
          .attr('linked_box', selected_mixmatch_grid)
          .html(`<img src="${parentImage}">`)
          .addClass('added');
      } else {
        console.warn("No empty slot available for new product!");
      }
    }
    
    $(this).toggleClass("active addtoset-checkbox-active");
    parentt.toggleClass("added_this_product", $(this).hasClass("addtoset-checkbox-active"));
  
    const activeCount = $('.addtoset-checkbox-active').length;
    atc_btn.disabled = activeCount !== max_itemAdd;
    $('.addprod_button.button').toggleClass('disabled', activeCount !== max_itemAdd);
    
    $('.mix_match_products').toggleClass('max_item_added', activeCount === max_itemAdd);
    $('.bundles-atc-wrapper').toggleClass('selection_disabled', activeCount === max_itemAdd);
    
    const label = $(this).children(".m-atc");
    label.text(label.text() === 'Add to Cart' ? 'Added' : 'Add to Cart');
    
    setTimeout(updateProgressBar, 200);
  });
  
  $(document).on('click', '.updatelist.added', function () {
    const removeProdId = $(this).attr('linked_box');
    $(`.addtoset-checkbox[data-proid="${removeProdId}"]`).trigger('click');
    setTimeout(updateProgressBar, 200);
  });

    /***** REPLACE original simple submit handler with the AJAX multi-add flow *****/
  $(document).on('click', '.bundles-atc', function (e) {
    e.preventDefault();

    // Elements & settings
    const $btn = $(this);
    const $form = $btn.closest('.product-card').find('.formbunder');
    const dealVariantFromAttr = $form.data('deal-variant'); // template-provided
    const dealTitleFromAttr = $form.data('deal-title') || '';
    const dealVariantFromInput = $form.find('input[name="id"]').val(); // fallback
    const dealVariantId = dealVariantFromAttr || dealVariantFromInput;

    // Gather selected bundle items
    const selectedEls = $('.addtoset-checkbox-active');
    const itemsToAdd = [];
    const productTitles = [];

    selectedEls.each(function () {
      const varId = $(this).data('varid') || $(this).attr('data-varid');
      const title = $(this).data('producttitle') || $(this).attr('data-producttitle') || '';
      if (varId) {
        itemsToAdd.push({
          id: parseInt(varId, 10),
          quantity: 1,
          // properties for each selected item (optional)
          properties: {
            '_Bundle-Parent': dealTitleFromAttr 
          }
        });
        productTitles.push(title);
      }
    });

    // Always add the deal product as the last item (with Bundle Details property)
    if (dealVariantId) {
      const bundleDetails = productTitles.length
        ? "\n- " + productTitles.join("\n- ")
        : '';

      itemsToAdd.push({
        id: parseInt(dealVariantId, 10),
        quantity: 1,
        properties: {
          'Bundle Details': bundleDetails || 'No additional products',
          'Bundle Items Count': String(productTitles.length)
        }
      });
    }

    // If nothing selected and no deal id — fallback to original submit
    if (itemsToAdd.length === 0) {
      // no JS additions possible, fallback
      $form.submit();
      return;
    }

    // UI feedback (keep your existing class usages)
    $('body').addClass('active_addcart');
    $btn.addClass('m-loader');

    // Sequentially add items via /cart/add.js to ensure proper cart lines
    function addItemAJAX(item) {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(item)
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Add failed');
        return res.json();
      });
    }

    // Run adds in sequence
    (async function () {
      try {
        for (let i = 0; i < itemsToAdd.length; i++) {
          await addItemAJAX(itemsToAdd[i]);
        }
        // Open Shopify’s cart drawer after all items are added
        fetch('/cart.js')
          .then(() => {
            document.body.dispatchEvent(
              new CustomEvent('cart:updated', { bubbles: true })
            );
          });
      } catch (err) {
        console.error('Bundle add AJAX error:', err);
        // If AJAX fails, fallback: submit original form (will add product__deal at least)
        $form.off('submit._bundle_fallback').on('submit._bundle_fallback', function () {
          // allow normal submit after binding fallback once
        });
        $form.submit();
      } finally {
        $btn.removeClass('m-loader');
        $('body').removeClass('active_addcart');
      }
    })();
  });

 
  function sticky_relocate() {
    const window_top = $(window).scrollTop();
    const div_top = $('#MainContent').offset()?.top || 0;
    const $wrapper = $('.bundles-atc-wrapper');

    if (window_top > div_top) {
      $wrapper.addClass('small').fadeIn(300);
    } else {
      $wrapper.removeClass('small').fadeOut(300);
    }
  }

  $(window).scroll(sticky_relocate);
  sticky_relocate();

  $(document).on('click', '.addprod_button.button', function () {
    $('body').addClass('active_addcart');
    $(this).addClass('m-loader');
    $('.bundles-atc').trigger('click');
  });

  /* --------------------------------------------------------------------
     🔥 PROGRESS BAR + FIREWORKS INTEGRATION (ADDED CODE BELOW)
  -------------------------------------------------------------------- */
  
  function updateProgressBar() {
    const activeCount = $('.addtoset-checkbox-active').length;
    const maxLimit = parseInt($('.featured-product.product').attr('max_limit'), 10) || 3;
    const remaining = Math.max(maxLimit - activeCount, 0);
    const progress = Math.min((activeCount / maxLimit) * 100, 100);
    $('#progressBar').css('width', progress + '%');
    const $btn = $('.bundles-atc.floating-atc span');
    if (remaining > 0) {
      $btn.text(`Add ${remaining} more product${remaining > 1 ? 's' : ''}`);
    } else {
      $btn.text(`Checkout`);
      triggerCrackers(); // 🎉 trigger cracker animation on 100%
    }
    $('.bundles-atc.floating-atc').prop('disabled', remaining > 0);
  }

   /* === 🔥 Fixed Suroskie-style cracker/confetti effect === */
 function triggerCrackers() {
  const overlay = document.getElementById('cracker-overlay');
  if (!overlay) return;

  overlay.innerHTML = ''; // purana canvas clear karo

  // ✅ Safe width/height measure
  const rect = overlay.getBoundingClientRect();
  const width = rect.width || window.innerWidth * 0.3; // fallback 30% width
  const height = rect.height || window.innerHeight; // fallback full height

  // create canvas with proper size
  const canvas = document.createElement('canvas');
  canvas.width = width * devicePixelRatio;
  canvas.height = height * devicePixelRatio;
  canvas.style.width = '100%';
  canvas.style.height = '100%';
  overlay.appendChild(canvas);

  const ctx = canvas.getContext('2d');
  ctx.scale(devicePixelRatio, devicePixelRatio);

  let particles = [];
  const colors = ['#FFDD00', '#FF6B6B', '#6BCB77', '#4D96FF', '#9D4EDD'];
  const gravity = 0.22; // thoda kam gravity = thoda upar tak jayega

  function rand(min, max) {
    return Math.random() * (max - min) + min;
  }

  function spawnBurst(count) {
    for (let i = 0; i < count; i++) {
      particles.push({
        x: width / 2 + rand(-40, 40),
        y: height - 50,
        vx: rand(-4, 4),
        vy: rand(-15, -8), // 🔥 thoda aur fast upward (zyada upar tak jayega)
        size: rand(4, 9),
        life: rand(70, 130),
        ttl: 0,
        color: colors[Math.floor(Math.random() * colors.length)],
        rotation: rand(0, Math.PI * 2),
        vr: rand(-0.15, 0.15),
      });
    }
  }

  // multiple small bursts
  spawnBurst(50);
  setTimeout(() => spawnBurst(30), 250);
  setTimeout(() => spawnBurst(20), 500);

  function animate() {
    ctx.clearRect(0, 0, width, height);
    for (let i = particles.length - 1; i >= 0; i--) {
      const p = particles[i];
      p.vy += gravity; // niche aate time slow feel
      p.x += p.vx;
      p.y += p.vy;
      p.rotation += p.vr;
      p.ttl++;

      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rotation);
      ctx.fillStyle = p.color;
      ctx.shadowBlur = 12;
      ctx.shadowColor = p.color;
      ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
      ctx.restore();

      if (p.ttl > p.life || p.y > height + 60) particles.splice(i, 1);
    }

    if (particles.length > 0) requestAnimationFrame(animate);
  }

  animate();
}
});